import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Whatmob() {
  return (
    <section className="what_mob p-100 text_color">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>What Did</span> We Do?
            </h2>
            <p>
              We conducted comprehensive market research, performed a
              competitive analysis for the client, and proposed additional
              features like multi-language support, leaderboards, in-app
              messaging, and friend request.Once TekRevol and the client agreed
              on the project scope and tech stack, we started development.
            </p>
            <div className="what_mob_img">
              <StaticImage
                src="../../../images/case-studies/parcheesi/what_mob_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1095}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whatmob;
